<template>
  <LsModal :title="t('areYouSure')" track-id="remove_service_modal">
    <template #footer>
      <LsButton
        :text="t('onboarding.yesSkip')"
        track-id="remove_service_modal-remove_service"
        :loading="onboarding.loadingStatus.isRemoving"
        test-id="remove_service"
        @click="removeService"
      />
    </template>
  </LsModal>
</template>

<script>
import { LsModal, LsButton } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import { ONBOARDING__REMOVE_SERVICE, ONBOARDING__REJECT_INSTANT_QUOTE } from '@/store/types';
import VueTypes from 'vue-types';
import _ from 'lodash';

export default {
  name: 'RemoveServiceModal',
  components: {
    LsModal,
    LsButton,
  },
  props: {
    orderserviceId: VueTypes.number.def(_.constant(null)),
    orderquoteId: VueTypes.number.def(_.constant(null)),
    instantQuoteId: VueTypes.number.def(_.constant(null)),
  },
  computed: {
    ...mapState(['onboarding']),
  },
  methods: {
    ...mapActions([ONBOARDING__REMOVE_SERVICE, ONBOARDING__REJECT_INSTANT_QUOTE]),
    removeService() {
      if (this.instantQuoteId) {
        this[ONBOARDING__REJECT_INSTANT_QUOTE]({
          instantQuoteId: this.instantQuoteId,
          formData: {
            reason: 'onboarding.removed',
            acceptable_price: 0,
          },
          onSuccess: () => {
            this.$parent.close();
          },
        });
      } else {
        this[ONBOARDING__REMOVE_SERVICE]({
          orderservice_id: this.orderserviceId,
          orderquote_id: this.orderquoteId,
          onSuccess: () => {
            this.$parent.close();
          },
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
